import videoIcon from '../../Assets/Icons/Teacher_s Dashboard/My Courses/doc_containing_video.svg'
import audioIcon from '../../Assets/Icons/New User/Course Page/study_material_icon.svg'
import attachmentIcon from '../../Assets/Icons/Teacher_s Dashboard/My Courses/attachment.svg'
import documentIcon from '../../Assets/Icons/Teacher_s Dashboard/My Courses/pdf.svg'

export const getFileIcon = ({ type = '', url }) =>
  type.includes('video')
    ? videoIcon
    : type.includes('image')
    ? url
    : type.includes('audio')
    ? audioIcon
    : type.includes('attachment')
    ? attachmentIcon
    : documentIcon
